import Vue from 'vue'
import App from './App.vue'
// px2rem 自适应
import 'lib-flexible'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
